import atsOptimizationImg from '../assets/images/blog/ats-optimization.jpg';
import techKeywordsImg from '../assets/images/blog/tech-keywords.jpg';

export const articlesData = {
  'your-chatgpt-resume-is-expediting-your-rejection': {
    id: 'your-chatgpt-resume-is-expediting-your-rejection',
    title: 'Your ChatGPT resume is expediting your rejection',
    excerpt: 'And what to do about it.',
    date: '2025-12-27',
    author: 'GimmeResume Team',
    readTime: '3 min read',
    image: atsOptimizationImg,
    content: `
      <p><strong>The current job market is broken</strong>. 
      
      <p>Ironically, it’s not because of the ATS keyword filters, those have been around for a while and haven’t changed much. It’s actually because everyone’s using ChatGPT to write their resume.</p>

      <p>If the average person is using ChatGPT to write their resume, then it is by definition making that resume average. So even if you’re heavily qualified, you’re submitting yourself as an average applicant.</p>
      <br />
      <p><strong>But how could this be? After all, ChatGPT is very good at writing. Two main problems:</strong></p>

      <ul>
        <li>ChatGPT writes based on its generalized and often outdated training data that doesn’t understand what the current market looks for in a candidate. This makes it pretty bad at writing a baseline resume.</li>
        <li>ChatGPT sucks at detecting keywords, and their importance. It’ll do its best job but it’s a model trained on generalized text at the end of the day, not a keyword detection model. So it writes your resume with generic representations of skills and keywords that won’t translate into what the ATS is looking for.</li>
      </ul>

      <p><strong>This leaves you with two options:</strong></p>

      <ul>
        <li>Only use ChatGPT for either a first draft or to suggest rewrites.</li>
        <li>Model the entire job market using a high-coverage ontology and several AI/ML models.</li>
      </ul>

      <p>Trust us on this, the first option is going to be much faster and easier.</p>

      <h2>Why should you listen to us?</h2>

      <p>We’ve spoken to over 100 recruiters over the past year about hiring for roles, how ATS systems work (over 90% of applications undergo keyword filtering), and how they process post-filtered candidate lists. Our founders have hands-on experience on how to succeed in getting your resume shortlisted for the interview process under adverse conditions. We built these tools by helping thousands of people land their next role in beta.</p>

      <p>There are more problems in the job-hiring process that exist on both sides, and the solutions have been baked into our tools.</p>
    `
  },
  // 'top-keywords-for-tech-jobs': {
  //   id: 'top-keywords-for-tech-jobs',
  //   title: 'Top Keywords for Tech Jobs in 2024',
  //   excerpt: 'Discover the most in-demand technical skills and keywords that recruiters are looking for.',
  //   date: '2024-01-10',
  //   author: 'GimmeResume Team',
  //   readTime: '7 min read',
  //   image: techKeywordsImg,
  //   content: `
  //     <p>The tech industry is constantly evolving, and so are the keywords that recruiters and ATS systems look for. Here are the most in-demand technical skills for 2024.</p>
      
  //     <h2>Programming Languages</h2>
  //     <ul>
  //       <li>Python - Still the most versatile and in-demand language</li>
  //       <li>JavaScript/TypeScript - Essential for web development</li>
  //       <li>Java - Continues to dominate enterprise development</li>
  //       <li>Go - Growing rapidly for backend and cloud applications</li>
  //     </ul>
      
  //     <h2>Cloud Technologies</h2>
  //     <p>Cloud skills are more important than ever:</p>
  //     <ul>
  //       <li>AWS (Amazon Web Services)</li>
  //       <li>Microsoft Azure</li>
  //       <li>Google Cloud Platform</li>
  //       <li>Docker and Kubernetes</li>
  //     </ul>
      
  //     <h2>Emerging Technologies</h2>
  //     <p>These technologies are seeing explosive growth in job postings:</p>
  //     <ul>
  //       <li>Artificial Intelligence and Machine Learning</li>
  //       <li>DevOps and CI/CD</li>
  //       <li>Cybersecurity</li>
  //       <li>Data Science and Analytics</li>
  //     </ul>
  //   `
  // }
};

// Helper function to get all articles as an array (for BlogPage)
export const getAllArticles = () => {
  return Object.values(articlesData).sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Helper function to get a specific article (for ArticlePage)
export const getArticleById = (id) => {
  return articlesData[id] || null;
};
